define('views/modals/metrik_add',['require','backbone','marionette','jquery-validation','text!templates/modals/metrik_add.html'],function (require) {
  var Backbone = require("backbone");
  require("marionette");
  require("jquery-validation");

  var temp = require("text!templates/modals/metrik_add.html");

  return Backbone.Marionette.LayoutView.extend({
    template: _.template(temp),
    className: "modal fade slide-up",
    errors: null,

    initialize: function (options) {
      this.callback = options.callback;
      this.customer = options.customer || App.user.get("customer");
      _.bindAll(this, "teardown");
    },

    ui: function () {
      return {
        emailField: "#email",
        yesButton: "#yes",
        noButton: "#no",
        mainForm: "#main-form",
      };
    },

    events: {
      "click @ui.yesButton": "yesButtonClicked",
      "click @ui.noButton": "noButtonClicked",
      "change form input": "formChanged",
    },

    setupFormValidation: function () {
      var _this = this;
    },

    templateHelpers: function () {
      return {
        confirmText: this.confirmText,
      };
    },

    onShow: function () {
      this.$el.modal();
    },

    show: function () {
      this.$el.modal("show");
      this.onShow();
    },

    teardown: function () {
      this.$el.data("modal", null);
      this.remove();
    },

    close: function () {
      this.$el.modal("hide");
    },

    yesButtonClicked: function () {
      var _this = this;

      var email = this.ui.emailField.val() || "";

      email = email.trim();

      this.ui.yesButton.addClass("loading");

      if (email) {
        $.ajax({
          url: App.Config.apiBase + "metrik-users/",
          type: "POST",
          data: {
            is_request: true,
            customer: _this.customer,
            email: email,
          },
          success: function (data) {
            _this.callback();

            _this.ui.yesButton.removeClass("loading");

            App.utils.showMessage(
              "success",
              App.polyglot.t("metrik_user_added_success")
            );
            _this.close();
          },

          error: function (xhr, ajaxOptions, thrownError) {
            _this.ui.yesButton.removeClass("loading");

            // Show error messages
            if (xhr.responseJSON.errors) {
              for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
                App.utils.showMessage(
                  "error",
                  xhr.responseJSON.errors[i].message
                );
              }
            } else {
              App.utils.showMessage(
                "error",
                App.polyglot.t("metrik_user_added_error")
              );
            }
          },
        });
      } else {
        _this.ui.yesButton.removeClass("loading");

        App.utils.showMessage("error", App.polyglot.t("email_required"));
      }
    },

    noButtonClicked: function () {
      this.close();
    },
  });
});

